'use client';

import Image from 'next/image';
import Testimonial from './Testimonial';
import { list } from './testimonial-list';
import config from '@/config';

export default function Testimonials() {
  const featuredTestimonial = list[list.length - 1];

  return (
    <section className="bg-paper-50 paper-grain relative" id="testimonials">
      <div className="py-20 lg:py-28 px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="font-hand text-brand-600 text-2xl mb-3 rotate-1 inline-block">
            from the faculty lounge
          </p>
          <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-[-0.02em] text-ink-900 leading-[1.02] mb-5">
            <span className="italic font-normal">Loved</span> by teachers
            <br />
            worldwide.
          </h2>
          <p className="font-display text-lg text-ink-600 leading-relaxed">
            See what educators have to say about {config.appName}.
          </p>
        </div>

        <ul
          role="list"
          className="grid max-w-2xl grid-cols-1 gap-6 mx-auto sm:gap-8 md:grid-cols-2 lg:max-w-none lg:grid-cols-4"
        >
          <li>
            <ul role="list" className="flex flex-col gap-y-6 sm:gap-y-8">
              {[...Array(3)].map((e, i) => (
                <Testimonial key={i} testimonial={list[i]} />
              ))}
            </ul>
          </li>

          <li className="hidden md:grid order-none md:order-first lg:order-none col-span-2 grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
            {/* Featured testimonial */}
            <ul className="col-span-2">
              <li>
                <figure className="relative h-full p-8 bg-paper-100 rounded-sm border border-ink-900/15 sticker -rotate-[0.4deg]">
                  <span
                    className="absolute -top-3 left-6 font-display italic text-7xl text-brand-500/70 leading-none"
                    aria-hidden="true"
                  >
                    &ldquo;
                  </span>
                  <blockquote className="relative pt-4">
                    <p className="font-display text-xl text-ink-900 leading-relaxed italic">
                      {featuredTestimonial.text}
                    </p>
                  </blockquote>
                  <figcaption className="relative flex items-center gap-4 pt-6 mt-6 border-t border-ink-900/15">
                    <div className="overflow-hidden rounded-full bg-paper-200 shrink-0">
                      {featuredTestimonial.img ? (
                        <Image
                          className="w-12 h-12 rounded-full object-cover"
                          src={featuredTestimonial.img}
                          alt={`${featuredTestimonial.name}'s testimonial`}
                          width={48}
                          height={48}
                        />
                      ) : (
                        <span className="w-12 h-12 rounded-full flex justify-center items-center font-display text-xl font-bold bg-paper-200 text-ink-900">
                          {featuredTestimonial.name.charAt(0)}
                        </span>
                      )}
                    </div>
                    <div>
                      <div className="font-display font-bold text-ink-900">
                        {featuredTestimonial.name}
                      </div>
                      {featuredTestimonial.username && (
                        <div className="text-sm text-ink-400">
                          @{featuredTestimonial.username}
                        </div>
                      )}
                    </div>
                  </figcaption>
                </figure>
              </li>
            </ul>
            <ul role="list" className="flex flex-col gap-y-6 sm:gap-y-8">
              {[...Array(2)].map((e, i) => (
                <Testimonial key={i} testimonial={list[i + 3]} />
              ))}
            </ul>
            <ul role="list" className="flex flex-col gap-y-6 sm:gap-y-8">
              {[...Array(2)].map((e, i) => (
                <Testimonial key={i} testimonial={list[i + 5]} />
              ))}
            </ul>
          </li>
          <li>
            <ul role="list" className="flex flex-col gap-y-6 sm:gap-y-8">
              {[...Array(3)].map((e, i) => (
                <Testimonial key={i} testimonial={list[i + 7]} />
              ))}
            </ul>
          </li>
        </ul>
      </div>
    </section>
  );
}
